module.exports = __webpack_public_path__ + "static/google-play-badge.db9b21a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/google-play-badge.png
// module id = 1002
// module chunks = 114276838955818